module.exports = __webpack_public_path__ + "img/thumbnail_WesternLowlandGorilla_f_normal.3551e53f.png";